export const API_PATH = {
  login: "auth/login/",
  signup: "auth/signup/",
  forgotPassword: "auth/forgot-password/",
  changePassword: "auth/change-password/",
  resetPassword: "auth/reset-password/",
  changePhoneNumber: "auth/user/profile/",
  me: "auth/me/",
  verifyAuthenticator: "auth/me/verify-authenticator/",
  verifyDisableTwoFactorOtp: "auth/me/verify-otp-for-authenticator/",
  disableMfaByToken: "auth/disable-mfa/",
};
